<template>
  <el-form :model="form" ref="form" class="address-form">
    <Button
      v-if="!storeAddress.length"
      buttonSize="big"
      buttonColor="blue"
      buttonText="Добавить другой адрес"
      @click.prevent="addAddress"
      class="add-button"
    />
    <Button
      v-else
      buttonSize="big"
      buttonColor="blue"
      buttonText="Удалить другой адрес"
      @click.prevent="deleteAddress"
      class="add-button"
    />
    <div class="flex-row" v-for="(item, i) in storeAddress" :key="item.id">
      <address-item
        :item="item"
        :index="i"
        :schema="schema"
        :disabled="disabledField"
        :parent-form="{ ...parentForm, ...originForm }"
        @set-value="setValue"
      />
    </div>
  </el-form>
</template>
<script>
import { store } from '@/store';
import { Form } from 'element-ui';
import AddressItem from 'Elements/AddressForm/AddressFormItem';
import { scrollToError, randomNumber } from '@/utils/helpers';
import Button from 'Elements/Button/Button';
export default {
  props: {
    field: {
      type: Object,
      default: () => ({})
    },
    model: {
      type: Array,
      default: () => []
    },
    schema: {
      type: Object,
      default: () => ({})
    },
    isPopup: {
      type: Boolean,
      default: false
    },
    disabledField: { type: Boolean, default: false },
    parentForm: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      form: {}
    };
  },
  created() {
    this.model && this.model.forEach(item => this.addAddress(item));
  },
  computed: {
    fields() {
      return store.state.vacancy.fields || {};
    },
    saveMode() {
      return store.state.common.detachedForm.saveMode;
    },
    storeAddress: {
      // обязательно в сторе в detachedForm.fields добавить пустое поле
      get() {
        return store.state.common.detachedForm.fields[this.field.name];
      },
      set(val) {
        store.commit('common/setDetachedFormFields', val);
      }
    },
    originForm() {
      const form = {};
      for (let key in this.form) {
        form[key.split('__')[1] || key] = this.form[key];
      }
      return form;
    }
  },
  methods: {
    deleteAddress() {
      this.form = {};
      this.storeAddress = {
        fieldName: this.field.name,
        form: []
      };
      store.commit('edit/resetAddress', false);
      this.validateForm();
    },
    setValue(item, index, fields = {}) {
      const address = [...this.storeAddress.slice()];

      for (let name in fields) {
        const value = fields[name];

        address[index].fields = item.fields.map(field =>
          field.name == name.split('__')[1]
            ? { name: name.split('__')[1], value }
            : field
        );

        this.$set(this.form, name, fields[name]);
      }

      this.storeAddress = {
        fieldName: this.field.name,
        form: address
      };
      this.validateForm();
    },
    formatField(data) {
      return {
        id: randomNumber(),
        fields: [
          {
            name: 'place_addr',
            value: data?.place_addr || ''
          },
          {
            name: 'city',
            value: data?.city || ''
          },
          {
            name: 'city_id',
            value: data?.city_id || ''
          },
          {
            name: 'subway_station',
            value: data?.subway_station || []
          },
          {
            name: 'subway_station_val',
            value: data?.subway_station_val || []
          },
          {
            name: 'comment',
            value: data?.comment || ''
          }
        ]
      };
    },
    addAddress(data = null) {
      const address = this.formatField(data);
      address.fields.forEach(({ name, value }) =>
        this.$set(this.form, `${address.id}__${name}`, value)
      );

      this.storeAddress = {
        fieldName: this.field.name,
        form: [address]
      };
      store.commit('edit/resetAddress', true);
      this.$emit('reset-address');
      this.validateForm();
    },
    validateForm() {
      let success = '';
      this.$nextTick(() => {
        this.$refs.form.validate(async (valid, fields) => {
          store.commit('common/setDetachedFormStatus', {
            name: this.field.name,
            valid
          });
          // detachedRules можно объединить с общими rules
          if (!valid) {
            const errorFields = Object.keys(fields);
            scrollToError(
              errorFields,
              this.isPopup ? this.$el.closest('.el-dialog__body') : window
            );
            store.commit('common/setDetachedFormMode', false);
          }
          success = valid;
        });
      });
      return success;
    }
  },
  watch: {
    saveMode: function () {
      if (this.saveMode) {
        const valid = this.validateForm();
        if (!valid) return;
        // эмит для форм редактирования
        this.$emit('save');
      }
    }
  },
  beforeDestroy() {
    store.commit('edit/resetAddress', false);
  },
  components: {
    'el-form': Form,
    AddressItem,
    Button
  }
};
</script>
<style lang="scss" scoped>
.flex-row {
  display: flex;
  margin-bottom: 12px;
}

.address-form {
  display: flex;
  flex-direction: column;

  & ::v-deep .el-form-item.is-required > .el-form-item__label:before {
    content: none;
  }

  & ::v-deep .el-form-item.is-required > .el-form-item__label:after {
    content: '*';
    color: #f56c6c;
    margin-left: 4px;
  }
}

.add-button {
  display: flex;
  align-items: center;
  align-self: flex-start;
}
</style>
